import { Progress } from 'antd'
import styled from 'styled-components'

export default styled(Progress)`
  .ant-progress-text[title] {
    color: rgba(0, 0, 0, 0.65) !important;
  }
`
